import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { SlideshowWidget } from "../osoigonext_core/Components/Slideshow.jsx";
import { Slide } from "../osoigonext_core/Components/Slide.jsx";

export function RenderSlideshow(configuration){
    const container = document.getElementById(configuration.container);
    const slidesDataContainer = document.getElementById(configuration.slideJSON);
    const slides = slidesDataContainer ? JSON.parse(slidesDataContainer.textContent || "[]") : [];
    const root = createRoot(container);

    root.render(
      (
        <SlideshowWidget configuration={configuration}>
          {slides.map((slide, idx) => (
            <Slide key={`slide-${idx}`} slide={slide} />
          ))}
        </SlideshowWidget>
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".slideshow-widget-config");

    for (let config of widget_configs) {
        RenderSlideshow(JSON.parse(config.innerText));
    }
});
